export default {
  'Has Receipt': {
    icon: 'fas fa-camera',
    color: '#4A90E2'
  },
  'No Receipt': {
    icon: 'fas fa-camera',
    color: '#989898'
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/filters/listIcons.js